import * as yup from "yup";

import { messagesConstants } from "@/constants";

export const createEventTemplateFormCreateTemplateEventFormSchema = yup.object({ title: yup.string().required(messagesConstants.inputsMsgs.title) });
